export interface FetchPortfolioInitPayload {
    applicationId: string
    emailId: string
    phoneNumber: string
    panNumber: string
    assetRepository: string
    isRetryAllowed: boolean
}

export interface FetchPortfolioVerifyPayload {
    applicationId: string
    assetRepository: string
    otp: string
}

export enum FetchPortfolioModalType {
    LOADER = "LOADER",
    IMMEDIATE = "IMMEDIATE"
}

export enum ACTION_TYPE {
    EDIT_DETAILS = "EDIT_DETAILS",
    CONTACT_US = "CONTACT_US",
    NO_ACTION = "NO_ACTION",
    KYC_UPDATE_ACTION = 'KYC_UPDATE_ACTION'
}

export interface FetchPortfolioError {
    retryType: FetchPortfolioModalType
    errorShown: string
    retryNextRTA: boolean
    header: string
    message: string
    primaryCtaAction: ACTION_TYPE | null
    primaryCtaText: string
    secondaryCtaAction: ACTION_TYPE | null
    secondaryCtaText: any
    tertiaryCtaAction: ACTION_TYPE | null
    tertiaryCtaText: string
    loaderTimingInMilliSec: number,
    errorCode?: string
}

export interface FetchPortfolioInitResponse {
    errorMessage: any
    status: string
    updatedApplicationObj: UpdatedApplicationObj
    stepResponseObject: StepResponseObject
    borrowerViewStepperMap: BorrowerViewStepperMap[]
    partnerViewStepperMap: any
}

export interface UpdatedApplicationObj {
    applicationId: string
    accountId: string
    coBorrowerAccountMetaData: any
    currentCoBorrowerAccountId: any
    applicationType: string
    applicationState: string
    applicationApprovalStatus: any
    creditAmount: any
    isBREComplete: any
    lenderAccountId: string
    partnerAccountId: any
    platformAccountId: string
    creditId: any
    currentStepId: string
    stepStatusMap: StepStatusMap
    createdOn: number
    lastUpdatedOn: number
    completedOn: any
    creditApplicationBusinessObjective: string
  }
  
export interface StepStatusMap {
    ASSET_PLEDGE: string
    MF_FETCH_PORTFOLIO: string
    LOAN_CONTRACT: string
    KYC_PAN_VERIFICATION: string
    MF_PLEDGE_PORTFOLIO: string
    KYC_PHOTO_VERIFICATION: string
    KYC_SUMMARY: string
    CREDIT_APPROVAL: string
    KYC_DOCUMENTS: string
    BANK_ACCOUNT_VERIFICATION: string
    DIGIO_MANDATE_SIGN: string
    KYC_ADDITIONAL_DETAILS: string
  }
  
export interface StepResponseObject {
    error: FetchPortfolioError
    success: FetchPortfolioSuccess | FetchPortfolioVerifySuccess
    originalErrorMsg: any
    isPanEditable?: boolean
  }
  
export interface FetchPortfolioSuccess {
    sessionId: string
    mfcOTPRef: string
    mfcReqId: number
    identifier: string
    otpChannel: string
    noOfDigits: number
}
  
export interface BorrowerViewStepperMap {
    status: string
    verticalDisplayName: string
    verticalDescription: string
    horizontalDisplayName: string
    order: number
}
  
export const AssetRepository = {
    CAMS: 'CAMS',
    KARVY: 'KARVY',
    MFCENTRAL: 'MFCENTRAL'
}

export interface FetchPortfolioVerifySuccess {
    applicationId: string
    totalPortfolioAmount: number
    pledgedPortfolioAmount: number
    availableCreditAmount: number
    requestedCreditAmount: number
    approvedCreditAmount: number
    nonEligiblePortfolioAmounts: NonEligiblePortfolioAmounts
    processingFees: number
    processingFeesBreakUp: ProcessingFeesBreakUp
    interestRate: number
    kfinCallBackReceived: any
    loanTenureInMonths: number
    isinLTVMap: any
    isinNAVMap: any
    repositoryAssetMetadataMap: RepositoryAssetMetadataMap
    availableCAS: AvailableCas[]
    nonEligiblePortfolio: NonEligiblePortfolio[]
    tobePledgedPortfolio: TobePledgedPortfolio[]
    pledgedPortfolio: any[]
    casFetchDates: CasFetchDates
    maxLoanAmount: number
    stampDutyState: string
    minimumEligibleLimit: MinimumEligibleLimit
  }
  
  export interface NonEligiblePortfolioAmounts {
    UnApprovedPortfolio: number
  }
  
  export interface ProcessingFeesBreakUp {
    "Processing Fee": number
    "Stamp duty (as per reg. state)*": number
  }
  
  export interface RepositoryAssetMetadataMap {
    KARVY: Karvy
    MFCENTRAL: Mfcentral
    CAMS: Cams
  }
  
  export interface Karvy {
    availablePortfolioAmount: number
    approvedPortfolioAmount: number
    availableCreditAmount: number
    approvedCreditAmount: number
    casFetchDate: any
  }
  
  export interface Mfcentral {
    availablePortfolioAmount: number
    approvedPortfolioAmount: number
    availableCreditAmount: number
    approvedCreditAmount: number
    casFetchDate: any
  }
  
  export interface Cams {
    availablePortfolioAmount: number
    approvedPortfolioAmount: number
    availableCreditAmount: number
    approvedCreditAmount: number
    casFetchDate: number
  }
  
  export interface AvailableCas {
    assetRepository: string
    assetSource: string
    amcName: string
    amcCode: string
    folioNo: string
    schemeCode: string
    emailId: any
    phoneNumber: any
    panNumber: any
    schemeName: string
    isinNo: string
    schemeType: string
    totalAvailableUnits: number
    fetchedOn: any
    is_pledged: any
    is_pledged_confirmed: any
    pledgedUnits: any
    pledgedOn: any
    pledgeReferenceNo: any
    modeOfHolding: string
    pledgingRemarks: any
    kfinIhno: any
    camsLienRefNumber: any
  }
  
  export interface NonEligiblePortfolio {
    assetRepository: string
    assetSource: string
    amcName: string
    amcCode: string
    folioNo: string
    schemeCode: string
    emailId: any
    phoneNumber: any
    panNumber: any
    schemeName: string
    isinNo: string
    schemeType: string
    totalAvailableUnits: number
    fetchedOn: any
    is_pledged: any
    is_pledged_confirmed: any
    pledgedUnits: any
    pledgedOn: any
    pledgeReferenceNo: any
    modeOfHolding: string
    pledgingRemarks: any
    kfinIhno: any
    camsLienRefNumber: any
  }
  
  export interface TobePledgedPortfolio {
    assetRepository: string
    assetSource: string
    amcName: string
    amcCode: string
    folioNo: string
    schemeCode: string
    emailId: any
    phoneNumber: any
    panNumber: any
    schemeName: string
    isinNo: string
    schemeType: string
    totalAvailableUnits: number
    fetchedOn: any
    is_pledged: boolean
    is_pledged_confirmed: any
    pledgedUnits: number
    pledgedOn: any
    pledgeReferenceNo: any
    modeOfHolding: string
    pledgingRemarks: any
    kfinIhno: any
    camsLienRefNumber: any
  }
  
  export interface CasFetchDates {
    CAMS: number
  }
  
  export interface MinimumEligibleLimit {
    amount: number
    nonEligibleDisplayReason: any
    isEligible: any
  }
  